<template>
  <v-container fluid>
    <h1>
      <v-icon>mdi-lock</v-icon>เปลี่ยนรหัสผ่าน
    </h1>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4" xl="3">
        <v-form @submit="changePassword">
          <v-card>
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>เปลี่ยนรหัสผ่าน</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-text-field
                id="password"
                label="รหัสผ่านเก่า"
                name="password"
                prepend-icon="mdi-lock"
                type="password"
                required
                v-model="password"
                :error-messages="passwordErrors"
                :disabled="loading"
                @input="$v.password.$touch()"
                @blur="$v.password.$touch()"
              ></v-text-field>
              <v-text-field
                id="newPassword"
                label="รหัสผ่านใหม่"
                name="newPassword"
                prepend-icon="mdi-lock"
                type="password"
                required
                v-model="newPassword"
                :error-messages="newPasswordErrors"
                :disabled="loading"
                @input="$v.newPassword.$touch()"
                @blur="$v.newPassword.$touch()"
              ></v-text-field>
              <v-text-field
                id="confirmPassword"
                label="ยินยันรหัสผ่านใหม่"
                name="confirmPassword"
                prepend-icon="mdi-lock"
                type="password"
                required
                v-model="confirmPassword"
                :error-messages="confirmPasswordErrors"
                :disabled="loading"
                @input="$v.confirmPassword.$touch()"
                @blur="$v.confirmPassword.$touch()"
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" :disabled="loading" :loading="loading" type="submit">Login</v-btn>
            </v-card-actions>
            <v-dialog v-model="loading" hide-overlay persistent disabled width="300">
              <v-card color="primary" dark>
                <v-card-text>
                  กำลังเปลี่ยนรหัสผ่านกรุณารอสักครู่
                  <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
export default {
  mixins: [validationMixin],
  validations: {
    password: { required },
    newPassword: { required },
    confirmPassword: { required },
  },
  data: () => {
    return {
      loading: false,
      password: "",
      newPassword: "",
      confirmPassword: "",
    };
  },

  computed: {
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push("กรุณาใส่ Password");
      return errors;
    },
    newPasswordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push("กรุณาใส่ Password");
      return errors;
    },
    confirmPasswordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push("กรุณาใส่ Password");
      return errors;
    },
  },
  methods: {
    async changePassword($e) {
      $e.preventDefault();
      this.loading = true;
      try {
        const data = await this.$store.dispatch("auth/changePassword", {
          password: this.password,
          newPassword: this.newPassword,
          confirmPassword: this.confirmPassword,
        });

        if (data && data.success && data.success == true) {
          this.$notify({
            type: "success",
            title: "สำเร็จ!",
            text: "ทำการเปลี่ยนรหัสผ่านเรียบร้อย กรุณา Login ใหม่อีกครั้ง",
          });
          this.$store.dispatch("auth/clearToken");
          this.$store.dispatch("auth/logout");
          this.$router.push({
            path: "/login",
          });
        } else if (data && !data.success && data.message) {
          this.$notify({
            type: "error",
            title: "Error",
            text: data.message,
          });
        } else {
          this.$notify({
            type: "error",
            title: "Error",
            text: "พบปัญหากับระบบกรุณาลองใหม่อีกครั้งภายหลัง",
          });
        }
      } catch (err) {
        const errMsg =
          (err &&
            err.response &&
            err.response.data &&
            err.response.data.message) ||
          err.message ||
          "พบปัญหากับระบบกรุณาลองใหม่อีกครั้งภายหลัง";
        this.$notify({
          type: "error",
          title: "Error",
          text: errMsg,
        });
      }
      this.loading = false;
    },
  },
};
</script>